import { showroomToast } from "./showroom-api";

// <showroom-export>: "Export lineup as PDF". Renders the lineup preview to a
// canvas (html2canvas) and saves it as a landscape A4 PDF (jsPDF). Both
// libraries are theme assets loaded on first use.

const loadedScripts = new Map();

function loadScript(src) {
  if (!loadedScripts.has(src)) {
    loadedScripts.set(
      src,
      new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.append(script);
      }),
    );
  }

  return loadedScripts.get(src);
}

class ShowroomExport extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("[data-export-pdf]");
    this.button?.addEventListener("click", () => this.save());
  }

  async save() {
    // The canvas is swapped in by lineup refreshes, so it's looked up here.
    const canvasEl = this.querySelector("[data-export-canvas]");
    if (!canvasEl) return;

    this.button.disabled = true;
    this.button.classList.add("is-loading");

    try {
      await Promise.all([loadScript(this.dataset.html2canvasUrl), loadScript(this.dataset.jspdfUrl)]);

      const canvas = await window.html2canvas(canvasEl, {
        scale: 2,
        useCORS: true,
        backgroundColor: getComputedStyle(canvasEl).backgroundColor,
      });

      const pdf = new window.jspdf.jsPDF("l", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const ratio = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);
      const width = canvas.width * ratio;
      const height = canvas.height * ratio;

      pdf.addImage(canvas.toDataURL("image/png"), "PNG", (pageWidth - width) / 2, (pageHeight - height) / 2, width, height);
      pdf.save(this.dataset.fileName || "bridal-party.pdf");
    } catch (error) {
      console.error("Lineup export failed.", error);
      showroomToast(this.closest("showroom-page")?.dataset.localeGenericError);
    } finally {
      this.button.disabled = false;
      this.button.classList.remove("is-loading");
    }
  }
}

if (!customElements.get("showroom-export")) {
  customElements.define("showroom-export", ShowroomExport);
}
